import {
    SET_ALL_PAYMENT_METHODS_DATA_LOADING,
    SET_PAYMENT_METHODS_DATA,
    SET_COMPANY_PAYMENT_METHODS_DATA_LOADING,
    SET_COMPANY_PAYMENT_METHODS_DATA,
    SET_ALL_PAYMENT_SETTINGS_DATA_LOADING,
    SET_PAYMENT_SETTINGS_DATA,
    CLEAR_PAYMENT_METHODS_DATA,
} from "../actions/types";

const initialState = {
    isLoading: false,
    paymentMethodsData: [],
    companyPaymentMethodsData: [],
    paymentSettingsData: [],
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_ALL_PAYMENT_METHODS_DATA_LOADING:
            return {
                ...state,
                isLoading: payload,
            };
        case SET_PAYMENT_METHODS_DATA:
            return {
                ...state,
                paymentMethodsData: Array.isArray(payload) ? [...payload] : [],
                isLoading: false,
            };
        case SET_COMPANY_PAYMENT_METHODS_DATA_LOADING:
            return {
                ...state,
                isLoading: payload,
            };
        case SET_COMPANY_PAYMENT_METHODS_DATA:
            return {
                ...state,
                companyPaymentMethodsData: Array.isArray(payload) ? [...payload] : [],
                isLoading: false,
            };
        case SET_ALL_PAYMENT_SETTINGS_DATA_LOADING:
            return {
                ...state,
                isLoading: payload,
            };
        case SET_PAYMENT_SETTINGS_DATA:
            return {
                ...state,
                paymentSettingsData: Array.isArray(payload) ? [...payload] : [],
                isLoading: false,
            };
        case CLEAR_PAYMENT_METHODS_DATA:
            return {
                ...state,
                paymentMethodsData: [],
                companyPaymentMethodsData: [],
                isLoading: false,
            };
        default:
            return state;
    }
}

